import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../shared/error-fallback";
import Nav from "./nav";
import { useInView } from "react-intersection-observer";
import useWindowSize from "../shared/window-size";
import getConfig from "../app/config";
import MarkettingBottomSection from "./marketing-bottom-section";
import "./marketing-page.scss";
import ScrollToTop from "./scroll-to-top";
import { Link } from "react-router-dom";

const MarketingPage = (props) => {
    const { backLink } = props;
    const windowSize: any = useWindowSize();
    const windowWidth = windowSize.width;
    const options = { threshold: 1, rootMargin: `${windowWidth > 936 ? "50" : "20"}px 0px 0px 0px`, initialInView: true };
    const [titleRef, titleInView] = useInView(options);

    const config = getConfig();
    const appUrl = config.appUrl;
    let registerUrl = config.appUrl + "/register";
    const onLogError = (error: Error, info) => {
        if (props.logError) {
            props.logError("marketing", error.message, error.stack, info.componentStack);
        }
    };

    return (
        <div className="marketing-background">
            <ErrorBoundary fallback={ErrorFallback}
                onError={onLogError}>
                <ScrollToTop />
                <Nav tranparent={false} appUrl={appUrl} registerUrl={registerUrl} />

                <div className="marketing-container">
                    <div className="marketing no-background">
                        <div className="marketing-content case-studies">
                            {backLink && <Link className="no-highlight back-link" to={backLink.url}><img className="back-arrow" src="/images/marketing/back-arrow.svg" />{backLink.text}</Link>}
                            <div className="marketing-page-content-container">
                                <div className="marketing-page-content" ref={titleRef}>
                                    {props.children}
                                </div>
                            </div>


                            <MarkettingBottomSection registerUrl={registerUrl} />
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        </div>
    );
}

export default MarketingPage;